<template>
  <div class="box box-primary" v-if="permissao">
    <div class="box-body">
      <div class="painel">
        <div class="notificacoes">
          <div class="cabecalho-notificacoes">
            <a href="javascript:void(0)">
              <div class="h2 mb-0 icon-detalhe-notificacao">
                <router-link to="/ListarNotificacoes"
                  ><b-icon-arrow-left-short></b-icon-arrow-left-short
                ></router-link>
              </div>
            </a>
            <h2>Notificação n° {{ notificacaoAtual.id }}</h2>
          </div>

          <table id="tabelaControle" class="table table-borderless">
            <tbody>
              <tr>
                <th>
                  <h4 class="sub-header">Dados da Notificação</h4>
                </th>
              </tr>

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Quem criou:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>{{ notificacaoAtual.usuario }}</td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Contrato:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>{{ notificacaoAtual.numero_contrato }}</td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Mês de referência:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>{{ notificacaoAtual.mes_referencia }}</td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Ano de referência:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>{{ notificacaoAtual.ano_referencia }}</td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Descrição:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>{{ notificacaoAtual.descricao }}</td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Data de envio:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>{{ notificacaoAtual.data_envio }}</td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Data resposta esperada:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td v-if="notificacaoAtual.data_resposta_esperada !== null">
                    {{ notificacaoAtual.data_resposta_esperada }}
                  </td>
                  <td v-else>
                    <p class="text-center">-</p>
                  </td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Arquivo:</strong></td>
                </div>

                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td v-if="notificacaoAtual.arquivo">
                    <a
                      class="downloadArquivo"
                      href="javascript:void(0)"
                      v-on:click="downloadArquivo(notificacaoAtual.arquivo)"
                      >Download</a
                    >
                  </td>
                  <td v-else><span class="downloadArquivo"> - </span></td>
                </div>
              </tr>
              <br />

              <tr>
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Status notificação</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td
                    v-if="notificacaoAtual.status === 'Concorda'"
                    class="text-center"
                  >
                    <span class="label label-success">{{
                      notificacaoAtual.status
                    }}</span>
                  </td>
                  <td
                    v-else-if="
                      notificacaoAtual.status === 'Sem resposta'
                    "
                    class="text-center"
                  >
                    <span class="label label-warning">{{
                      notificacaoAtual.status
                    }}</span>
                  </td>
                  <td v-else class="text-center">
                    <span class="label label-danger">{{
                      notificacaoAtual.status
                    }}</span>
                  </td>
                </div>
              </tr>
              <br />

              <!-- <tr v-if="notificacaoAtual.status">
                <th>
                  <h4 class="sub-header">Retorno do Fornecedor</h4>
                </th>
              </tr>

              <tr v-if="notificacaoAtual.status">
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Quem respondeu:</strong></td>
                </div>

                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>
                    {{ notificacaoAtual.status.quem_respondeu }}
                  </td>
                </div>
              </tr>
              <br />

              <tr v-if="notificacaoAtual.status">
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Para quem ela foi enviada:</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td
                    v-for="i in notificacaoAtual.status
                      .email_envio"
                  >
                    <p v-if="i.email === '' || i.email === null">-</p>
                    <p v-else>{{ i.email }}</p>
                  </td>
                </div>
              </tr>
              <br />

              <tr v-if="notificacaoAtual.status">
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Justificativa do fornecedor</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>
                    {{
                      notificacaoAtual.status.observacao_fornecedor
                    }}
                  </td>
                </div>
              </tr>
              <br />

              <tr v-if="notificacaoAtual.status">
                <div class="col-xs-12 col-sm-4 col-md-4">
                  <td><strong>Data da resposta</strong></td>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-8">
                  <td>
                    {{ notificacaoAtual.status.data_resposta }}
                  </td>
                </div>
              </tr>
              <br />
              <div class="col-xs-12 col-sm-4 col-md-4">
                <tr>
                  <strong>Histórico</strong>
                </tr>
                <td>
                  <historico-notificacoes :historico="historico" />
                </td>
              </div> -->
            </tbody>
          </table><hr>

          <template>
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                  <b-button v-b-toggle="'accordion-2'" :class="'text-head'"><strong>Histórico</strong></b-button>
                </b-card-header>
                <b-collapse :id="'accordion-2'">
                  <b-card-body class="bcard01">
                    <table id="tabelaControleHistorico" class="table table-borderless">
                      <tbody>
                        <tr v-for="(item, index) in historico" :key="index">
                          <td colspan="2">                            
                            <p><b>Nome: </b> {{ item.usuario }}</p>
                            <p><b>Email: </b> {{ item.email }}</p>
                            <p><b>Ação: </b>{{ item.acao}}</p>
                            <p><b>Data: </b>{{ formataData(item.created_at)}}</p>
                            <p><b>UF: </b>{{ item.uf}}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </template>

          <!-- <div
            v-if="
              this.usuarioGrupos.includes('fornecedor') &&
              notificacaoAtual.status === 'Sem resposta' 
            "
          >
            <button
              class="btn btn-historico btn-success"
              variant="primary"
              data-toggle="modal"
              data-target="#exibirNotificacao"
            >
              Avaliar Notificação
            </button>
          </div>
          <div v-else>
            <p class="text-primary"><b> Notificação já respondida </b></p>
          </div> -->
        </div>
        <input type="hidden" :value="notificacaoAtual" />
      </div>
    </div>
  </div>
</template>

<script>
import HistoricoNotificacoes from './HistoricoNotificacoes.vue'
export default {
  components: { HistoricoNotificacoes },
  data () {
    return {
      notificacaoAtual: [],
      historico: [],
      controlerLoadingDownload: true,
      env: process.env,
      gruposPermitidos: ['oi', 'admin'],
      permissao: true
    }
  },
  mounted: function () {
    this.getGrupos()
    // Array com grupos do usuário
    let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
    // msg(setPermissaoNegada) - função verificando se o usuário possui mais de um grupo(max 3)
    let msgGrupos = usuarioGrupo[0].nome
    if (usuarioGrupo[1]) {
      msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome
      if (usuarioGrupo[2]) {
        msgGrupos =
          usuarioGrupo[0].nome +
          ' ,' +
          usuarioGrupo[1].nome +
          ' ,' +
          usuarioGrupo[2].nome
      }
    }
    if (
      this.usuarioGrupos.includes('admin') === true ||
      this.usuarioGrupos.includes('oi') === true
    ) {
      this.getNotificacaoAtual()
    } else {
      this.permissao = false
      this.$store.commit('setPermissaoNegada', {
        msg: `Seu(s) grupo(s) de usuário [${msgGrupos}] não permite(m) acesso a esta área.`,
        status: false,
        show: true
      })
    }
  },
  computed: {
    notificacao: function () {
      let notificacaoId = this.$route.query.id
      let vm = this
      this.$store.commit('setNotificacaoAtual', '')
      this.$axios
        .get(
          `${this.env.FINANCEIRO.NOTIFICACAO}/gethistorico/${notificacaoId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        }
        )
        .then(function (response) {
          let { notificacao, historico } = response.data
          vm.notificacaoAtual = notificacao
          vm.historico = historico
          vm.$store.commit('setNotificacaoAtual', vm.notificacaoAtual)
        })
      this.getNotificacaoAtual()
      return notificacao
    }
  },
  methods: {
    getNotificacaoAtual () {
      let notificacaoId = this.$route.query.id
      let vm = this
      this.$store.commit('setNotificacaoAtual', '')
      this.$axios
        .get(
          `${this.env.FINANCEIRO.NOTIFICACAO}/gethistorico/${notificacaoId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        }
        )
        .then(function (response) {
          let { notificacao, historico } = response.data
          vm.notificacaoAtual = notificacao
          vm.historico = historico
          vm.$store.commit('setNotificacaoAtual', vm.notificacaoAtual)
        })
    },
    downloadArquivo: function (nomeArquivo) {
      let vm = this
      let dirBucket = 'notificacoes'
      this.controlerLoadingDownload = false
      this.$axios
        .get(
          `${this.env.FINANCEIRO.NOTIFICACAO}/downloadarquivo/${dirBucket}/${nomeArquivo}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        }
        )
        .then(function (response) {
          vm.controlerLoadingDownload = true
          // Condição espefifica para acesso não autorizado retornado pela API predial-adm
          if (response.data.mensagem) {
            vm.$store.commit('setAlert', {
              msg: response.data.mensagem,
              status: false,
              show: true
            })
            return
          }
          window.open(response.data.url, '_blank')
        })
    },
    getGrupos () {
      let grupos = []
      this.$store.state.login.loginUsuario.grupo.forEach(function (element) {
        grupos.push(element.nome)
      })
      this.usuarioGrupos = grupos
    },
    formataData: function (dataForm) {
      var dataArray = dataForm.split(' ')
      var data = dataArray[0].split('-')
      let horarioArray = dataArray[1].split(':')

      var hora = horarioArray[0]
      var minuto = horarioArray[1]
      return data[2] + '/' + data[1] + '/' + data[0] + ' ' + hora + ':' + minuto
    }
  }
}
</script>

<style scoped src="./css/exibirNotificacao.css"></style>



// WEBPACK FOOTER //
// ExibirNotificacao.vue?20cb1c9c